import { Component, createRef } from 'react';

// Fades + slides an element in once it scrolls into view (Apple-style reveal).
// Usage: <Reveal as="div" className="my-section">...</Reveal>
class Reveal extends Component {
    ref = createRef();
    state = { visible: false };

    componentDidMount() {
        const el = this.ref.current;
        if (!el) return;

        if (typeof IntersectionObserver === 'undefined') {
            this.setState({ visible: true });
            return;
        }

        this.observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.setState({ visible: true });
                        this.observer.unobserve(el);
                    }
                });
            },
            { threshold: 0.15, rootMargin: '0px 0px -80px 0px' }
        );
        this.observer.observe(el);
    }

    componentWillUnmount() {
        if (this.observer) this.observer.disconnect();
    }

    render() {
        const { as: Tag = 'div', className = '', delay = 0, children, ...rest } = this.props;
        const { visible } = this.state;

        return (
            <Tag
                ref={this.ref}
                className={`reveal${visible ? ' reveal--visible' : ''}${className ? ' ' + className : ''}`}
                style={visible ? { transitionDelay: `${delay}ms` } : undefined}
                {...rest}
            >
                {children}
            </Tag>
        );
    }
}

export default Reveal;
